<div mat-dialog-title>
  {{ modalData.title }}
  <div style="float: right; margin-top: -5px;">

    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content *ngIf="modalData.isEdit" class="mat-typography">
  <mat-spinner *ngIf="isLoading" diameter="40" style="margin: 0 auto;"></mat-spinner>
  <div class="row">
    <div ngbRadioGroup class="col-6 col-lg-3 col-md-4 col-sm-4 justify-content-center text-center"
      *ngFor="let item of profileList" [(ngModel)]="orgPic" (change)="formChange(item)">
      <label ngbButtonLabel class="btn-avatars m-2">
        <input ngbButton type="radio" [value]="item" ngbButton>
        <img [src]="item.IMAGE_URL" [id]="item.IMAGE_NAME" class="img-avatar img-fluid" alt="" />
      </label>
    </div>
  </div>
</mat-dialog-content>

<div *ngIf="modalData.isEdit" align="center" style="padding-bottom: 20px; padding-top: 20px;">
  <button mat-button style="background: #3E8C1A; color: #fff;" (click)="selectAvatar()">
    {{ modalData.actionBtnText }}
  </button>
</div>
